import { NgModule } from '@angular/core';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IvyCarouselModule } from 'ng-responsive-carousel';
import { CompanyCardComponent } from './components/company-card/company-card.component';
import { CompanyRanksCarouselComponent } from './components/company-ranks-carousel/company-ranks-carousel.component';
import { PodcastListComponent } from './components/podcast-list/podcast-list.component';
import { FeaturedListWeekComponent } from './components/featured-list-week/featured-list-week.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FeaturedArticleComponent } from './components/featured-article/featured-article.component';
import { ArticleListComponent } from './components/article-list/article-list.component';
import { ExpandableBoardsListComponent } from './components/expandable-boards-list/expandable-boards-list.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { GradePerformanceComponent } from './components/grade-performance/grade-performance.component';
import { DirectorshipProfileComponent } from './components/directorship-profile/directorship-profile.component';
import { PortfolioListComponent } from './components/portfolio-list/portfolio-list.component';
import { CompanyCardRankComponent } from './components/company-card-rank/company-card-rank.component';
import { DirectorCardComponent } from './components/director-card/director-card.component';
import { WatchlistListComponent } from './components/watchlist-list/watchlist-list.component';
import { DirectorStatListComponent } from './components/director-stat-list/director-stat-list.component';
import { CompanyMapChartComponent } from './components/company-map-chart/company-map-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { MatTabsModule } from '@angular/material/tabs';
import { ReportCompanyPrintComponent } from './components/report-company-print/report-company-print.component';
import { RouterLink } from '@angular/router';
import { CalculateAgePipe } from './pipes/calculate-age.pipe';
import { JoinArrayPipe } from './pipes/join-array.pipe';
import { YearRangePipe } from './pipes/year-range.pipe';
import {
  CdkDetailRowDirective,
  PlaceHolderImageLoadingDirective,
} from './directives';
import { ExpandableRankingListComponent } from './components/expandable-ranking-list/expandable-ranking-list.component';
import { CallbackPipe } from './pipes/callback.pipe';
import { ShortenNamePipe } from './pipes/shorten-name.pipe';
import { CompanyWatchlistBtnComponent } from './components/company-watchlist-btn/company-watchlist-btn.component';
import { CompanyLogoComponent } from './components/company-logo/company-logo.component';
import { CompanyPortfolioBtnComponent } from './components/company-portfolio-btn/company-portfolio-btn.component';
import { DirectorCardImgComponent } from './components/director-card-img/director-card-img.component';
import { DirectorCardGradedImgComponent } from './components/director-card-graded-img/director-card-graded-img.component';
import { CompanyTopRanksComponent } from './components/company-top-ranks/company-top-ranks.component';
import { HtmlToTextPipe } from './pipes/html-to-text.pipe';
import { ArticleExternalProcPipe } from './pipes/article-external-proc.pipe';
import { MatSortModule } from '@angular/material/sort';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ReportDirectorPrintComponent } from './components/report-director-print/report-director-print.component';
import { CompanyInfoComponent } from './components/company-info/company-info.component';
import { DirectorshipProfileModalComponent } from './components/directorship-profile-modal/directorship-profile-modal.component';
import { CompanyInfoSummaryComponent } from './components/company-info-sumary/company-info-summary.component';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IvyCarouselModule,
    ScrollingModule,
    InlineSVGModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatTableModule,
    NgChartsModule,
    MatTabsModule,
    RouterLink,
    MatSortModule,
    MatTableExporterModule,
    MatToolbarModule,
  ],
  declarations: [
    DateAgoPipe,
    CalculateAgePipe,
    JoinArrayPipe,
    HtmlToTextPipe,
    YearRangePipe,
    CallbackPipe,
    ShortenNamePipe,
    ArticleExternalProcPipe,
    CompanyCardComponent,
    CompanyRanksCarouselComponent,
    PodcastListComponent,
    PortfolioListComponent,
    FeaturedListWeekComponent,
    FeaturedArticleComponent,
    ArticleListComponent,
    DirectorshipProfileComponent,
    DirectorshipProfileModalComponent,
    ExpandableBoardsListComponent,
    ExpandableRankingListComponent,
    CompanyWatchlistBtnComponent,
    DirectorCardGradedImgComponent,
    CdkDetailRowDirective,
    PlaceHolderImageLoadingDirective,
    CompanyPortfolioBtnComponent,
    GradePerformanceComponent,
    CompanyCardRankComponent,
    DirectorCardImgComponent,
    CompanyLogoComponent,
    CompanyTopRanksComponent,
    DirectorCardComponent,
    WatchlistListComponent,
    DirectorStatListComponent,
    CompanyMapChartComponent,
    CompanyInfoComponent,
    ReportCompanyPrintComponent,
    ReportDirectorPrintComponent,
    CompanyInfoSummaryComponent,
  ],
  exports: [
    DateAgoPipe,
    CalculateAgePipe,
    JoinArrayPipe,
    HtmlToTextPipe,
    ArticleExternalProcPipe,
    YearRangePipe,
    CallbackPipe,
    ShortenNamePipe,
    CompanyCardComponent,
    CompanyRanksCarouselComponent,
    PodcastListComponent,
    PortfolioListComponent,
    FeaturedListWeekComponent,
    CompanyWatchlistBtnComponent,
    FeaturedArticleComponent,
    DirectorCardGradedImgComponent,
    ArticleListComponent,
    DirectorshipProfileComponent,
    DirectorshipProfileModalComponent,
    ExpandableBoardsListComponent,
    DirectorCardImgComponent,
    ExpandableRankingListComponent,
    CompanyPortfolioBtnComponent,
    CompanyLogoComponent,
    CompanyTopRanksComponent,
    GradePerformanceComponent,
    CompanyCardRankComponent,
    DirectorCardComponent,
    WatchlistListComponent,
    DirectorStatListComponent,
    CompanyMapChartComponent,
    CompanyInfoComponent,
    ReportCompanyPrintComponent,
    ReportDirectorPrintComponent,
    PlaceHolderImageLoadingDirective,
    CompanyInfoSummaryComponent,
  ],
})
export class SharedModule {}
